<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Cadastro"
>
  @if(dano.CB1COD !== ''){
    <po-container class="po-md-12">
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Etiqueta Expedição" [p-value]="dano.CZ02COD"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Cód Romaneio" [p-value]="dano.CZ02CODZ00"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Lote" [p-value]="dano.CZ02LOTE"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Produto" [p-value]="dano.CB1COD"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Descrição Produto" [p-value]="dano.CB1DESC"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Pedido" [p-value]="dano.CC5NUM"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Código Cliente" [p-value]="dano.CC5CLIENTE"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Loja Cliente" [p-value]="dano.CC5LOJACLI"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Nome Cliente" [p-value]="dano.CA1NOME"></po-info>
      <po-info class="po-sm-12 po-md-3 po-mt-2 po-font-text-small" p-label="Quantidade Original" [p-value]="dano.NB8QTDORI"></po-info>

      <po-select
        class="po-md-3"
        name="CZ03RESPON"
        p-label="Responsável por Ações"
        [(ngModel)]="dano.CZ03RESPON"
        [p-options]="responsavelLista"
        [p-required]="true"
      ></po-select>

      <po-select
        class="po-md-3"
        name="CZ03ENVLOT"
        p-label="Enviado Lote para SOLIDA"
        [(ngModel)]="dano.CZ03ENVLOT"
        [p-options]="envLoteLista"
        [p-required]="true"
      ></po-select>

      <po-lookup
        class="po-md-3"
        name="CZ03MOTIVO"
        [(ngModel)]="dano.CZ03MOTIVO"
        p-label="Motivo"
        p-field-value="CZPRCHAVE"
        p-field-label="CZPRGENERI"
        [p-columns]="ColumnsFilters"
        [p-field-format]="FieldFormaterFilter"
        [p-filter-service]="zprLookupService"
        [p-advanced-filters]="advancedFilter"
        [p-literals]="{ modalTitle: 'Motivo' }"
        [p-required]="true"
        [p-auto-height]="true"
      ></po-lookup>

      <po-input
        [p-auto-focus]="true"
        class="po-md-9"
        name="CZ03OBS"
        [(ngModel)]="dano.CZ03OBS"
        p-label="Observação"
      ></po-input>

      <po-button class="po-md-12" p-kind="secondary" p-label="Salvar" (p-click)="salvar()"></po-button>

    </po-container>
  }
</po-page-default>
